import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { ReportProps, RootState } from "../../interfaces/containers";
import { FetchingTypes } from "../../interfaces/types";
import { getLinkPayment, getDataPayment,getPaymentProcess } from "../../actions/linzeCheck";
import {getPlateInfo } from "../../actions/salePost";
import { UserProps } from "../../interfaces/app";
import CongratulationsPageSell from "../../pages/CongratulationsPageSell/EntryPoint/CongratulationsPageSell";

function mapStateToProps(state: RootState) {
    return {
        user: state.auth.user,
        publicationInfo: state,
        fetchingPlateInfo: state.salePost.fetchingPlateInfo,
        payment: state.report,
        dataPayment: state.report?.dataPayment
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getLinkPayment,
        getDataPayment,
        getPlateInfo,
        getPaymentProcess
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CongratulationsPageSell);